function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmClockClockSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47A7DD"
    },
    d: "M107.357,501.11c-1.106,0-2.229-0.196-3.324-0.609c-4.868-1.837-7.327-7.273-5.49-12.142 l24.305-64.429c1.839-4.87,7.274-7.327,12.143-5.49c4.868,1.837,7.327,7.273,5.49,12.142l-24.305,64.429 C114.751,498.784,111.165,501.11,107.357,501.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47A7DD"
    },
    d: "M404.644,501.11c-3.808,0-7.394-2.326-8.819-6.1l-24.304-64.429 c-1.837-4.868,0.622-10.306,5.49-12.143c4.871-1.834,10.305,0.621,12.143,5.492l24.304,64.429 c1.837,4.868-0.622,10.306-5.49,12.143C406.873,500.914,405.749,501.11,404.644,501.11z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFCA6C"
    },
    cx: 256.001,
    cy: 266.894,
    r: 208.02
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M418.82,266.894c0,89.932-72.896,162.828-162.815,162.828c-20.454,0-40.028-3.769-58.058-10.654 c-61.261-23.381-104.77-82.695-104.77-152.173c0-89.92,72.896-162.828,162.828-162.828c24.148,0,47.064,5.264,67.682,14.7 C379.822,144.46,418.82,201.123,418.82,266.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M418.82,266.894c0,89.932-72.896,162.828-162.815,162.828c-20.454,0-40.028-3.769-58.058-10.654 l125.739-300.301C379.822,144.46,418.82,201.123,418.82,266.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCA6C"
    },
    d: "M483.788,175.367l-53.396-53.384c-0.05-0.05-0.088-0.088-0.126-0.138l-14.612-14.599L347.52,39.112 c30.103-30.103,75.157-36.121,111.24-18.067v0.013c9.021,4.498,17.489,10.529,25.027,18.054 C521.404,76.74,521.404,137.751,483.788,175.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2AE5A"
    },
    d: "M458.761,21.045v0.013c0,0-81.615,47.454-28.495,100.787l-14.612-14.599L347.52,39.112 C377.623,9.009,422.677,2.991,458.761,21.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCA6C"
    },
    d: "M28.22,175.373c-37.626-37.626-37.626-98.631,0-136.258s98.631-37.626,136.258,0l-68.129,68.129 L28.22,175.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2AE5A"
    },
    d: "M71.563,39.115c13.262-13.262,29.433-21.828,46.457-25.741c-31.274-7.189-65.436,1.377-89.8,25.741 c-37.626,37.626-37.626,98.631,0,136.258l25.212-25.212C35.49,114.107,41.516,69.162,71.563,39.115z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47A7DD"
    },
    d: "M256.001,276.319h-45.177c-5.205,0-9.423-4.219-9.423-9.423s4.218-9.423,9.423-9.423h35.754v-66.678 c0-5.204,4.218-9.423,9.423-9.423c5.205,0,9.423,4.219,9.423,9.423v76.101C265.424,272.1,261.206,276.319,256.001,276.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47A7DD"
    },
    d: "M256.001,141.8c-5.205,0-9.423-4.219-9.423-9.423v-28.304c0-5.204,4.218-9.423,9.423-9.423 c5.205,0,9.423,4.219,9.423,9.423v28.304C265.424,137.581,261.206,141.8,256.001,141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47A7DD"
    },
    d: "M256.001,439.143c-5.205,0-9.423-4.219-9.423-9.423v-28.304c0-5.204,4.218-9.423,9.423-9.423 c5.205,0,9.423,4.219,9.423,9.423v28.304C265.424,434.925,261.206,439.143,256.001,439.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47A7DD"
    },
    d: "M418.825,276.319h-28.304c-5.205,0-9.423-4.219-9.423-9.423s4.218-9.423,9.423-9.423h28.304 c5.205,0,9.423,4.219,9.423,9.423S424.029,276.319,418.825,276.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47A7DD"
    },
    d: "M121.481,276.319H93.177c-5.205,0-9.423-4.219-9.423-9.423s4.218-9.423,9.423-9.423h28.303 c5.205,0,9.423,4.219,9.423,9.423S126.685,276.319,121.481,276.319z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2AE5A"
    },
    d: "M256.005,439.145c-21.166,0-41.83-3.793-61.42-11.275c-32.25-12.309-59.814-33.816-79.711-62.194 c-20.358-29.036-31.121-63.195-31.121-98.783c0-94.979,77.272-172.251,172.252-172.251c24.958,0,49.049,5.234,71.603,15.554 c61.133,27.981,100.635,89.489,100.635,156.697C428.243,361.874,350.978,439.145,256.005,439.145z M256.005,113.49 c-84.587,0-153.406,68.817-153.406,153.405c0,31.696,9.58,62.113,27.706,87.963c17.728,25.285,42.28,44.445,71.002,55.407 c17.437,6.659,35.838,10.035,54.698,10.035c84.58,0,153.392-68.817,153.392-153.405c0-59.858-35.183-114.638-89.632-139.559 C299.69,118.148,278.238,113.49,256.005,113.49z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClockClockSvgrepoCom);
export default __webpack_public_path__ + "static/media/alarm-clock-clock-svgrepo-com.2d71908068ebc6481ad4731305e0ccd3.svg";
export { ForwardRef as ReactComponent };